import { render, staticRenderFns } from "./AtacamaDesert.vue?vue&type=template&id=7f4aee32&"
import script from "./AtacamaDesert.vue?vue&type=script&lang=js&"
export * from "./AtacamaDesert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports